export {
  default,
  type ToggleSwitchDescriptionPosition,
  type ToggleSwitchSize,
  type ToggleSwitchCheckedProps,
  type ToggleSwitchSimpleCheckedProps,
  type ToggleSwitchBaseProps,
  type ToggleSwitchProps,
  type ToggleSwitchComponentProps,
  type ToggleSwitchPropTypes,
} from './ToggleSwitch';
